<template lang="pug">
div(v-if="this.purchase_invoice !== null")
  UiCardSection
    UiStack
      UiStackItem
        UiButton(
          variant="smooth-primary"
          @click="close()"
          icon="ArrowLeft"
        ) Back
      UiStackItem
        UiCard(
          shadow="never"
          border="always"
        )
          UiCardSection
            strong Netvisor key: {{ this.purchase_invoice.remote_key }}
      UiStackItem
        UiCard(
          shadow="never"
          border="always"
        )
          UiCardSection
            strong {{ this.purchase_invoice.status }}
      UiStackItem
        UiCard(
          shadow="never"
          border="always"
        )
          UiCardSection
            strong {{ this.purchase_invoice.status_reason }}
  UiCardSection
    UiTabs(
      :tabs="tabs"
      :selected="activeTab"
      @select="activeTab = $event"
      skin="light"
    )
  UiCardSection
    DataTab(
      v-if="activeTab === 'data'"
      :data="this.purchase_invoice.data"
      :line_items="this.purchase_invoice.invoice_lines"
    )
    VoucherTab(
      v-if="activeTab === 'voucher'"
      :data="this.purchase_invoice.voucher_hash"
      :line_items="this.purchase_invoice.invoice_lines"
    )
    XMLTab(
      v-if="activeTab === 'finvoice'"
      :data="this.purchase_invoice.finvoice"
      :attachments="this.purchase_invoice.finvoice_attachment"
    )
    XMLTab(
      v-if="activeTab === 'netvisor_document'"
      :data="this.purchase_invoice.original_document"
    )
    HistoryTab(
      v-if="activeTab === 'history'"
      :data="this.purchase_invoice.history"
    )
    AttachmentsTab(
      v-if="activeTab === 'attachments'"
      :data="this.purchase_invoice.attachments"
    )
</template>

<script>
import ApiPurchaseInvoices from "@/api/purchase_invoices";
import DataTab from "@/views/PurchaseInvoice/tabs/data.vue";
import VoucherTab from "@/views/PurchaseInvoice/tabs/voucher.vue";
import XMLTab from "@/views/PurchaseInvoice/tabs/xml.vue";
import HistoryTab from "@/views/PurchaseInvoice/tabs/history.vue";
import AttachmentsTab from "@/views/PurchaseInvoice/tabs/attachments.vue";

export default {
  components: {
    DataTab,
    VoucherTab,
    XMLTab,
    HistoryTab,
    AttachmentsTab,
  },

  props: ["id"],

  data() {
    return {
      activeTab: "data",
      purchase_invoice: null,
      selected: this.$route.query.invoice_tab || DataTab,
    };
  },

  computed: {
    tabs() {
      return [
        {
          id: "data",
          label: "Data",
        },
        {
          id: "voucher",
          label: "Voucher",
          visible: this.purchase_invoice.voucher_hash !== null,
        },
        {
          id: "finvoice",
          label: "Finvoice",
          visible: this.purchase_invoice.finvoice !== null,
        },
        {
          id: "netvisor_document",
          label: "Netvisor document",
          visible: this.purchase_invoice.original_document !== null,
        },
        {
          id: "history",
          label: "History",
          visible: this.purchase_invoice.history !== null,
        },
        {
          id: "attachments",
          label: "Attachments",
          visible:
            this.purchase_invoice.attachments !== null &&
            this.purchase_invoice.attachments.length !== 0,
        },
      ].filter((item) => item.visible ?? true);
    },
  },

  watch: {
    id: {
      immediate: true,
      handler(_v, _ov) {
        this.fetchInvoice();
      },
    },
  },

  methods: {
    close() {
      const { invoice_id, ...rest } = this.$route.query;
      this.$router.push({ ...this.$route, query: rest });
    },

    fetchInvoice() {
      ApiPurchaseInvoices.fetchPurchaseInvoice(this.id).then((resp) => {
        this.purchase_invoice = resp.data.purchase_invoice;
      });
    },
  },
};
</script>
